import { useSWRConfig } from 'swr'

export const useRevalidateAllSwrCache = () => {
  const { cache, mutate } = useSWRConfig()
  return () => {
    if (!(cache instanceof Map)) {
      throw new Error('matchMutate requires the cache provider to be a Map instance')
    }

    const keys = []

    for (const key of cache.keys()) {
      keys.push(key)
    }

    const mutations = keys.map((key) => mutate(key))
    return Promise.all(mutations)
  }
}
